<template>
  <div ref="ask-analyst-hist" class="ask-analyst-hist chat-application">
    <div v-if="hist && hist.length > 0" class="chat-app-window">
        <div class="active-chat">
            <div class="user-chats" v-for="(msgGrp, index) in hist" :key="index">
                <div class="chats">
                    <!-- QUESTION -->
                    <div class="chat">
                        <div class="chat-avatar">
                            <b-avatar variant="transparent" size="36" class="avatar-border-2 box-shadow-1">
                                <feather-icon icon="UserIcon" />
                            </b-avatar>
                            <!-- <small>{{getUserName}}</small> -->
                            <!-- <b-avatar
                                size="32"
                                class="avatar-border-2 box-shadow-1"
                                variant="transparent"
                                :text="getUserName"
                            /> -->
                            <!-- <vs-avatar :text="currentUser.nome" class="avatar center"></vs-avatar> -->
                        </div>
                        <div class="chat-body">
                            <div class="chat-content">
                                <small>{{formatFullDate(msgGrp.dt_create, {dateStyle: "medium", timeStyle: "short"})}}</small>
                                <p>{{ msgGrp.question }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- ANSWER -->
                    <div class="chat chat-left">
                        <div class="chat-avatar" v-if="msgGrp.user_answer">
                            <b-avatar
                                size="36"
                                class="avatar-border-2 box-shadow-1"
                                variant="transparent"
                                :src="msgGrp.user_answer.image_path"
                            />
                            <!-- <small>{{msgGrp.user_answer.nickname}}</small> -->
                        </div>
                        <div class="chat-body">
                            <div
                                v-for="msgData in msgGrp.answer"
                                :key="msgData.dt_sent"
                                class="chat-content"
                            >
                                <small>{{msgGrp.user_answer.nickname}}</small>
                                <!-- <small>{{formatFullDate(msgData.dt_sent, {dateStyle: "medium", timeStyle: "short"})}}</small> -->
                                <p>{{ msgData.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div><b>Data: </b> {{formatFullDate(item.dt_create, {dateStyle: "short"})}}</div>
                <div><b>Pergunta:</b> {{item.question}} </div>
                <div><b>Resposta:</b> 
                    <author-info v-if="item.user_answer" class="author cursor-pointer w-full flex author-high"  :displayNickname="true" :author="item.user_answer"></author-info>
                    <div v-for="(a, indexx) in item.answer" :key="indexx">
                        <p>{{formatFullDate(a.dt_sent, {dateStyle: "short"})}}</p>
                        <p>{{a.text}}</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    <template v-else>
        Nenhum histórico de pergunta
    </template>
  </div>
</template>

<script>
import { BCard, BAvatar } from 'bootstrap-vue'
import AuthorInfo from '../../../layouts/components/customizer/AuthorInfo.vue'
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
export default {
    components: {
        BCard,
        BAvatar,
        AuthorInfo,
    },
    props: {
        hist: {
            require: true,
            default: []
        }
    },
    watch: {
        hist(val) {
            if (val && val.length > 0) {
                setTimeout(() => {
                    this.$refs['ask-analyst-hist'].scrollTo(0, this.$refs['ask-analyst-hist'].scrollHeight);
                }, 500);
            }
        }
    },
    computed: {
        getUserName() {
            if (!this.currentUser && !this.currentUser.nome) {
                return "";
            }
            const split = this.currentUser.nome.split(" ");
            return `${split[0]} ${split[split.length - 1]}`;
        },
        currentUser() {
            return this.$store.state.AppActiveUser;
        }
    },
    methods: {
        formatFullDate(val, obj) {
            return convertDatetimeHelper.formatFullDateTimezone(val, obj);
        },
    }
}
</script>

<style lang="scss">
    @import "~@core/scss/base/pages/app-chat.scss";
    @import "~@core/scss/base/pages/app-chat-list.scss";
</style>